/**
 * Component that renders if no dishes have been ordered.
 */
export default function NoOrder() {
    return <p className="no-order text-center"> You haven't ordered anything yet. </p>;
}